import React from 'react'
import { cx } from '../lib/cx'

type Props = React.HTMLAttributes<HTMLDivElement> & {
  rounded?: 'md' | 'full'
}

export function Skeleton({ className, rounded = 'md', ...rest }: Props) {
  const r = rounded === 'full' ? 'rounded-full' : 'rounded-lg'
  return (
    <div
      className={cx(
        'animate-pulse bg-muted/15',
        r,
        className,
      )}
      {...rest}
    />
  )
}
